// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -716072795
// </auto-generated>
import {
  StringLength,
  RegularExpression,
  Required,
  EmailAddress,
  MinValue,
} from 'carehub-shared/validators';
import { Address } from '../../models/facility/address';

export class Facility {
  @Required()
  facilityId: string;
  managementCompanyId: string;
  metroAreaId: number;
  parentId: string;
  @Required()
  statusId: number;
  @Required()
  typeId: number;
  @StringLength(100)
  dba: string;
  @StringLength(255)
  email: string;
  @StringLength(50)
  fax: string;
  @StringLength(256)
  legalName: string;
  @StringLength(256)
  name: string;
  @StringLength(10)
  npi: string;
  @StringLength(50)
  phone: string;
  @StringLength(16)
  tin: string;
  @StringLength(3000)
  notes: string;
  @StringLength(255)
  url: string;
  inactiveDate: Date | string;
  createdUserId: string;
  updatedUserId: string;
  createdDate: Date | string;
  updatedDate: Date | string;
  addresses: Address[];
}

export function initializeNewFacility(): Facility {
  const instance = new Facility();
  instance.facilityId = '00000000-0000-0000-0000-000000000000';
  instance.managementCompanyId = '00000000-0000-0000-0000-000000000000';
  instance.metroAreaId = null;
  instance.parentId = '00000000-0000-0000-0000-000000000000';
  instance.statusId = null;
  instance.typeId = null;
  instance.dba = '';
  instance.email = '';
  instance.fax = '';
  instance.legalName = '';
  instance.name = '';
  instance.npi = '';
  instance.phone = '';
  instance.tin = '';
  instance.notes = '';
  instance.url = '';
  instance.inactiveDate = null;
  instance.createdUserId = '00000000-0000-0000-0000-000000000000';
  instance.updatedUserId = '00000000-0000-0000-0000-000000000000';
  instance.createdDate = null;
  instance.updatedDate = null;
  instance.addresses = null;
  return instance;
}
